export const isDeviceWidth = (width) => {
	if (window.matchMedia && window.matchMedia(`(max-width: ${width}px)`).matches) {
		return true;			
	}
	return false;
};
